export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}
export interface SortedRequestDto {
  sort?: string
  order?: SortDirection
}
